module.exports = __webpack_public_path__ + "img/icon-const-norm-bg-8.e2690f4f.png";